<template>
  <div class="card" v-show="currentCardId == 'edu-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>学歴を入力</h2>
        <p>「自動入力」を使うと、入学・卒業年度を自動で計算できます</p>
        <el-checkbox v-model="formatData.notDisplayIjyo"
          >【以上】を表示しない</el-checkbox
        >
      </div>
      <div class="card-content-list">
        <div class="add-item">
          <div class="edu-history-action">
            <AutoEducationalBackgrounds
              :year="basicData.birthYear"
              :month="basicData.birthMonth"
              :day="basicData.birthDay"
              @create-educational-background="setEducationalBackgrounds"
            />
            <div class="button-reset">
              <el-button
                v-if="
                  formatData.educationalHistories &&
                  formatData.educationalHistories.length > 1
                "
                @click="educationalResetVisible = true"
                >リセット</el-button
              >
            </div>
            <NewRirekishoResetDialog
              :value="educationalResetVisible"
              name="educational-reset"
              title="学歴リセット"
              message="入力されている学歴をすべて削除します。よろしいですか？"
              actions-class="text-left"
              @input="educationalResetVisible = $event"
              @confirm="resetEducationalBackgrounds"
            />
          </div>
        </div>
        <div class="edit-form-item">
          <div class="item-name">
            卒業予定 <span style="color: red">※卒年は必ず入力しましょう</span>
          </div>
          <div class="item-body">
            <el-select
              v-model="formatData.gradeYear"
              placeholder="選択してください"
            >
              <el-option
                v-for="item in gradeYearOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>

        <div class="edit-form-list">
          <transition-group name="fade" tag="div">
            <HistoryItem
              v-for="(item, index) in formatData.educationalHistories"
              :key="item.uuid"
              :item="item"
              :length="formatData.educationalHistories.length"
              :index="index"
              :id="item.uuid"
              :class="{ active: activeHistoryItem == item.uuid }"
              :minYear="basicData.birthYear"
              :createDate="formatData.createDate"
              :descriptionPlaceholder="'学歴を入力'"
              :descriptionMaxLength="descriptionMaxLength"
              @add-history-item="addEducationalHistory"
              @delete-history-item="deleteEducationalHistory"
              @move-history-item="moveEducationalHistory"
              @click.native="activateHistoryItem(item.uuid)"
            />
          </transition-group>
          <div class="add-list-item">
            <el-button
              icon="el-icon-plus"
              circle
              type="success"
              @click="addEducationalHistory()"
            />
          </div>
          <div
            class="attention-limit column"
            v-if="previewErrors.eduJobHistory"
          >
            <i class="el-icon-warning"></i> {{ previewErrors.eduJobHistory }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import AutoEducationalBackgrounds from '@/components/formats/RirekishoParts/AutoEducationalBackgrounds.vue'
import NewRirekishoResetDialog from '@/components/format-edit/new-rirekisho/NewRirekishoResetDialog.vue'
import gradeYearOptions from '@/utils/format-edit/newRirekishoGradeYearOptions.json'
import { useNewRirekishoFormatData } from '@/composables/format-edit/useNewRirekishoFormatData'
import { useNewRirekishoHistoriesApi } from '@/composables/format-edit/useNewRirekishoHistories'

const descriptionMaxLength = 80

defineProps<{
  currentCardId?: string
  basicData: Record<string, unknown>
  previewErrors: Record<string, string>
}>()

const formatData = useNewRirekishoFormatData()
const {
  activeHistoryItem,
  setEducationalBackgrounds,
  resetEducationalBackgrounds,
  addEducationalHistory,
  deleteEducationalHistory,
  moveEducationalHistory,
  activateHistoryItem
} = useNewRirekishoHistoriesApi()

const educationalResetVisible = ref(false)
</script>
